export const staircaseConfig = {
    gameSlug: 'sequence',
    category: 'eau_memoire',
    variable: 'n_items',
    startValue: 3,
    minValue: 2,
    maxValue: 9,
    stepSizesByPhase: [1, 1, 1],
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
    // MVP : 24 essais max (< 5 min test live).
    maxTrials: 24,
    direction: 'down-easier',
};
function buildVariant(level) {
    if (level <= 10) {
        return { level, itemDurationMs: 1000, mode: 'digits', label: 'Chiffres simples' };
    }
    if (level <= 20) {
        return { level, itemDurationMs: 800, mode: 'digits', label: 'Tempo soutenu' };
    }
    if (level <= 30) {
        return { level, itemDurationMs: 700, mode: 'colors', label: 'Couleurs visuelles' };
    }
    if (level <= 40) {
        return { level, itemDurationMs: 600, mode: 'colors', label: 'Tempo rapide' };
    }
    return { level, itemDurationMs: 500, mode: 'colors', label: 'Limite phonologique' };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
/** Durees non-staircase (fixation, pre-sequence, gap, feedback, ITI). */
export const timing = {
    fixationMs: 400,
    preSequenceMs: 600,
    gapMs: 200,
    feedbackMs: 700,
    itiMs: 700,
};
/** Vocabulaire couleurs (8 teintes distinctes du systeme paper). */
export const COLOR_PALETTE = [
    { key: 'sage-deep', bg: '#3f6b56', label: 'Sauge profond' },
    { key: 'terra-base', bg: '#b85c44', label: 'Terre' },
    { key: 'ocre-warm', bg: '#d6a85e', label: 'Ocre' },
    { key: 'air-deep', bg: '#4a6a82', label: 'Air profond' },
    { key: 'paper-deep', bg: '#e6decc', label: 'Papier' },
    { key: 'sage-pale', bg: '#a8c7b1', label: 'Sauge pale' },
    { key: 'terra-pale', bg: '#e7b1a2', label: 'Terre pale' },
    { key: 'ink-soft', bg: '#5b5a55', label: 'Encre douce' },
];
export const paradigmMeta = {
    slug: 'sequence',
    paradigm: 'Serial digit/color span (Conway et al. 2002)',
    masterMage: 'Ondine (eau-memoire)',
    category: 'eau_memoire',
    goal: 'Memoire sequentielle : codes, instructions, langues, listes.',
};
//# sourceMappingURL=params.js.map